/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  Text,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { RestatementofComparatives } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function RestatementofComparativesUpdateForm(props) {
  const {
    id: idProp,
    restatementofComparatives: restatementofComparativesModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    ComparativeStatementName: "",
    CorrectedDisclosureElement: "",
    CorrectedInformation: "",
  };
  const [ComparativeStatementName, setComparativeStatementName] =
    React.useState(initialValues.ComparativeStatementName);
  const [CorrectedDisclosureElement, setCorrectedDisclosureElement] =
    React.useState(initialValues.CorrectedDisclosureElement);
  const [CorrectedInformation, setCorrectedInformation] = React.useState(
    initialValues.CorrectedInformation
  );
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = restatementofComparativesRecord
      ? { ...initialValues, ...restatementofComparativesRecord }
      : initialValues;
    setComparativeStatementName(cleanValues.ComparativeStatementName);
    setCorrectedDisclosureElement(cleanValues.CorrectedDisclosureElement);
    setCorrectedInformation(cleanValues.CorrectedInformation);
    setErrors({});
  };
  const [restatementofComparativesRecord, setRestatementofComparativesRecord] =
    React.useState(restatementofComparativesModelProp);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? await DataStore.query(RestatementofComparatives, idProp)
        : restatementofComparativesModelProp;
      setRestatementofComparativesRecord(record);
    };
    queryData();
  }, [idProp, restatementofComparativesModelProp]);
  React.useEffect(resetStateValues, [restatementofComparativesRecord]);
  const validations = {
    ComparativeStatementName: [],
    CorrectedDisclosureElement: [],
    CorrectedInformation: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          ComparativeStatementName,
          CorrectedDisclosureElement,
          CorrectedInformation,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(
            RestatementofComparatives.copyOf(
              restatementofComparativesRecord,
              (updated) => {
                Object.assign(updated, modelFields);
              }
            )
          );
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "RestatementofComparativesUpdateForm")}
      {...rest}
    >
      <Heading
        level={4}
        children="Restatement of Comparatives"
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Heading>
      <Heading
        children="NZCS3 Paragraphs 43-46."
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Heading>
      <Text
        children="Update this record to describe any changes in information you will disclose in the current reporting period, compared to the previous period. Examples may include to correct a material error, change a method, use more current estimates or reflect changes in the nature of your business activities."
        {...getOverrideProps(overrides, "SectionalElement3")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement4")}
      ></Divider>
      <TextField
        label="Comparative statement name"
        isRequired={false}
        isReadOnly={false}
        value={ComparativeStatementName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              ComparativeStatementName: value,
              CorrectedDisclosureElement,
              CorrectedInformation,
            };
            const result = onChange(modelFields);
            value = result?.ComparativeStatementName ?? value;
          }
          if (errors.ComparativeStatementName?.hasError) {
            runValidationTasks("ComparativeStatementName", value);
          }
          setComparativeStatementName(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "ComparativeStatementName",
            ComparativeStatementName
          )
        }
        errorMessage={errors.ComparativeStatementName?.errorMessage}
        hasError={errors.ComparativeStatementName?.hasError}
        {...getOverrideProps(overrides, "ComparativeStatementName")}
      ></TextField>
      <TextAreaField
        label="Changed disclosure element"
        isRequired={false}
        isReadOnly={false}
        value={CorrectedDisclosureElement}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              ComparativeStatementName,
              CorrectedDisclosureElement: value,
              CorrectedInformation,
            };
            const result = onChange(modelFields);
            value = result?.CorrectedDisclosureElement ?? value;
          }
          if (errors.CorrectedDisclosureElement?.hasError) {
            runValidationTasks("CorrectedDisclosureElement", value);
          }
          setCorrectedDisclosureElement(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "CorrectedDisclosureElement",
            CorrectedDisclosureElement
          )
        }
        errorMessage={errors.CorrectedDisclosureElement?.errorMessage}
        hasError={errors.CorrectedDisclosureElement?.hasError}
        {...getOverrideProps(overrides, "CorrectedDisclosureElement")}
      ></TextAreaField>
      <TextAreaField
        label="Changed information"
        isRequired={false}
        isReadOnly={false}
        value={CorrectedInformation}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              ComparativeStatementName,
              CorrectedDisclosureElement,
              CorrectedInformation: value,
            };
            const result = onChange(modelFields);
            value = result?.CorrectedInformation ?? value;
          }
          if (errors.CorrectedInformation?.hasError) {
            runValidationTasks("CorrectedInformation", value);
          }
          setCorrectedInformation(value);
        }}
        onBlur={() =>
          runValidationTasks("CorrectedInformation", CorrectedInformation)
        }
        errorMessage={errors.CorrectedInformation?.errorMessage}
        hasError={errors.CorrectedInformation?.hasError}
        {...getOverrideProps(overrides, "CorrectedInformation")}
      ></TextAreaField>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Divider>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || restatementofComparativesModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || restatementofComparativesModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
